const emitJourneyEvent = (event) => {
  if (!(event.target instanceof Element)) return;
  const target = event.target.closest('[data-dl-journey-event]');
  if (!target || target.matches(':disabled, [aria-disabled="true"]')) return;
  target.dispatchEvent(new CustomEvent('delulu:journey', {
    bubbles: true,
    detail: {
      event: target.dataset.dlJourneyEvent,
      context: target.dataset.dlJourneyContext || '',
    },
  }));
};

const init = (scope = document) => {
  scope.querySelectorAll('[data-dl-size-guide-dialog]').forEach((dialog) => {
    if (dialog.dataset.dlDialogReady === 'true') return;
    dialog.dataset.dlDialogReady = 'true';
    const picker = dialog.closest('variant-picker');
    const trigger = picker?.querySelector('[data-dl-size-guide-trigger]');
    const closeButton = dialog.querySelector('[data-dl-size-guide-close]');
    trigger?.addEventListener('click', () => dialog.showModal());
    closeButton?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') dialog.close();
    });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => trigger?.focus());
  });
};

window.DeluluPurchaseJourney = { init };

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => init(), { once: true });
} else {
  init();
}

document.addEventListener('shopify:section:load', (event) => init(event.target));
document.addEventListener('click', emitJourneyEvent);
